import getConfig from '../../../scripts/utils/config-utils.js';

export default function isPriorityExpired(publishedTime) {
  try {
    const publishedDate = new Date(publishedTime * 1000);
    const maxDays = getConfig('article.priority.maxDays');
    const expirationDate = new Date(
      publishedDate.setDate(publishedDate.getDate() + +maxDays),
    );

    return expirationDate < new Date();
  } catch (error) {
    return false;
  }
}
